import { useEffect, useState } from "react";
import { sendStepUserJourney } from "@/api/userJourney";
import Button from "@/components/Button";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Form from "@/components/Form";
import useTabsValidation from "@/hooks/useTabsValidation";
import Layout from "@/components/Layout";
import { useFormStore } from "@/store/form";
import { useProductStore } from "@/store/product";
import { getOnlyNumbers } from "@/utils";
import {
  removeAccentAndSpaceAndSetLowerCase,
  removeAccentsAndSetUpperCase,
} from "@/utils/string";
import { GenericObject } from "@/utils/types";
import TypeProductForm from "@/components/TypeProduct";
import usePageSubmit from "@/hooks/usePageSubmit";
import SEO from "@/components/SEO";
import { formatPrice } from "@/utils/currency";
import { useTagManager } from "@/hooks/useTagManager";

type PageConfig = {
  route: string;
  prevRoute: string;
  nextRoute: string;
};

const defaultPageConfig = {
  route: "/personal-data/type-product",
  prevRoute: "/personal-data",
  nextRoute: "/address-info",
};

export function PersonalDataTypeProductPage() {
  const { dataLayer } = useTagManager();
  const form = useFormStore((store) => store.value);
  const addBonusPortability = useProductStore(
    (store) => store.addBonusPortability
  );
  const removeBonusPortability = useProductStore(
    (store) => store.removeBonusPortability
  );
  const product = useProductStore((store) => store.item);
  const shouldAddSpecialBonus = useProductStore(
    (store) => store.shouldAddSpecialBonus
  );
  const currentPrice = useProductStore((store) =>
    store.getCurrentPrice(getOnlyNumbers(form.tel).slice(0, 2))
  );
  const totalGbProduct = useProductStore((store) => store.getTotalGbProduct());

  const [pageConfig, setPageConfig] = useState<PageConfig>(defaultPageConfig);

  useEffect(() => {
    const complementFilled = form.found;
    if (!complementFilled) {
      setPageConfig({
        ...defaultPageConfig,
        nextRoute: "/personal-data/complement",
      });
    }
  }, [form, setPageConfig]);

  useTabsValidation(pageConfig.route, pageConfig.prevRoute);

  const [typeProductSelected, setTypeProductSelected] = useState(
    form.tipo || "MIGRACAO"
  );

  const handlerGBProduct = () => {
    if (form.tipo === "PORTABILIDADE" || shouldAddSpecialBonus()) {
      addBonusPortability();
    } else {
      removeBonusPortability();
    }
  };
  const submitCallback = usePageSubmit(pageConfig.nextRoute);
  const handleOnSubmit = (formData: GenericObject) => {
    dataLayer({
      event: "step",
      passo: "TIPO-DE-SOLICITACAO",
      sku: removeAccentsAndSetUpperCase(product?.tim_id),
      nome_produto: `${removeAccentAndSpaceAndSetLowerCase(
        product?.nome
      )}-${totalGbProduct}`,
      valor: formatPrice(currentPrice),
      status: "Sucesso",
    });
    handlerGBProduct();
    submitCallback({ ...formData, tipo: typeProductSelected });
  };

  const onClickForwardButton = (nextRoute: string) => {
    let passo = "ENDERECO";

    if (nextRoute === "/personal-data/complement") {
      passo = "DADOS_PESSOAIS_COMPLEMENTO";
    }

    sendStepUserJourney({
      passo,
      uuid: form.uuid,
    });
  };

  return (
    <Layout>
      <SEO
        title="Dados Pessoais - Complemento"
        description="Adicione os dados pessoais do titular da conta para continuar comprando seu plano TIM!"
      />
      <Columns
        as={Form}
        className="pt-2"
        alignItems="start"
        justifyContent="center"
        onSubmit={handleOnSubmit}
      >
        <Column size={12}>
          <TypeProductForm
            typeProductSelected={typeProductSelected}
            setTypeProductSelected={setTypeProductSelected}
          />
        </Column>

        <Column size={12}>
          <Button
            type="submit"
            large
            onClick={() => {
              onClickForwardButton(pageConfig.nextRoute);
            }}
          >
            Continuar
          </Button>
        </Column>
        <Column size={12} className="mt-8">
          <Button
            type="button"
            kind="secondary"
            large
            to={pageConfig.prevRoute}
          >
            Voltar
          </Button>
        </Column>
      </Columns>
    </Layout>
  );
}
export default PersonalDataTypeProductPage;
